import { frontendURL } from '../../../../helper/URLHelper';

const requests = accountId => ({
  parentNav: 'requests',
  routes: ['list_requests', 'list_organization'],
  menuItems: [
    {
      icon: 'list',
      label: 'TICKETS_MY_LIST',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/requests/list`),
      toStateName: 'list_requests',
    },
    {
      icon: 'list',
      label: 'TICKETS_LIST_ORGANIZATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/requests/organization`),
      toStateName: 'list_organization',
    },
  ],
});

export default requests;
